<div class="sheet-header">
  <ng-container>Area Setup</ng-container>

  <div class="space-block">

  </div>
</div>

<mat-progress-bar mode="indeterminate" *ngIf="progressBarLoading"></mat-progress-bar>

<div #table class="sheet-table">

</div>


<div class="loading-block" *ngIf="customTableLoading">
  <lib-progress-spinner></lib-progress-spinner>
</div>
